import store from '@/store/store';
import { CATEGORIE_LOCATION } from '@/configuration/produitConf';

export function incrementRef(ref) {
  const prefix = ref.slice(0, 3);
  const number = parseInt(ref.slice(3), 10) + 1;
  return prefix + number.toString().padStart(8, '0');
}

export function getProduitDefault(categorie) {
  const produitsLocation = store.getters['recommandations/produitsLocation'];
  let location = produitsLocation.find(p => categorie.id === p.id);
  if (location) return location;
  const societe = store.getters['societe/societeActive'];
  location = produitsLocation.find(p => p.id === societe.produitAssocieLocationFaceId
    || p.libelle.toUpperCase().includes(CATEGORIE_LOCATION.toUpperCase()));
  return location || null;
}

export function getCategorieFromProduit(lignesCommande) {
  const produitsLocation = store.getters['recommandations/produitsLocation'];
  const ligneCommandeLocation = lignesCommande.filter(l => l.produit)
    .find(l => l.produit.supportCommercial.categorieVente === CATEGORIE_LOCATION);
  if (!ligneCommandeLocation) return null;
  const produitLocationFind = produitsLocation.find(p => p.id === ligneCommandeLocation.produitId);
  return produitLocationFind ? {
    id: produitLocationFind.id,
    libelle: produitLocationFind.libelle,
    couleur: produitLocationFind.couleurHtmlRgb }
  : null;
}
